/**
 * Servicio: Log de correos
 * Endpoint: /wslogcorreos/getCorreosWS
 *
 * Obtiene información detallada de los correos enviados
 * **********************Replica: activate/stateless "WSDIAGNOSTICOS".get(vParams, vOutputDiagnos)
 */

import { sendRequest } from '../../config';

// ============================================================================
// TIPOS
// ============================================================================


export interface getCorreosparams {
  /** Código del país */
  cpais: string;
  /** Código del sistema donde se ejecuta */
  csistema?: string;
  /** Código referente al contenido del correo */
  ctipo_correo?: string;
}

export interface correo {
 // cpais: string;
  csistema: string;
  fcorreo: string;
  ctipo_correo: string;
  [key: string]: any;
}
// ============================================================================
// SERVICIO
// ============================================================================

/**
 * Obtiene información del correo 
 * * @param params - Parámetros de búsqueda (cpais, csistema, ctipo_correo)
 * @returns Información del tratamiento
 *
 * @example
 * ```ts
 * const tratamiento = await getTratamiento({
 *   "csistema":"n8n",
 *   ctipo_correo: 'Poliza_RC'
 * });
 * ```
 */
   export const getCorreosWS = async (params: getCorreosparams): Promise<Array<correo>> => {
   
    const ENDPOINT = 'wslogcorreos/getCorreosWS';
   return sendRequest({
     method: 'post',
     path: ENDPOINT,
     body: params,
   });
 };
 